import React from "react"
import Img from "gatsby-image";
import styled from '@emotion/styled';
import { darkThemeColors, breakpoints } from '../../util/styles';
import { Icon } from 'semantic-ui-react';
import { Link } from '@reach/router';

/**
 * Individual product listing within the container
 */
const ProductListingItem = props => {
  const { product } = props;

  return (
    <ProductListingItemLink to={product.id}>
      <Item>
        <Preview>
          {retriveProductImg(product)};
          <Name>{product.frontmatter.title}</Name>
          <Description>{product.frontmatter.description}</Description>
          <PriceRow>
            <Price>
              <span>USD</span> ${product.frontmatter.price}
            </Price>
            <Icon circular color='teal' name='shopping cart' />
          </PriceRow>
        </Preview>
      </Item>
    </ProductListingItemLink>
  );

  function retriveProductImg(product) {
    if(product.frontmatter.image.childImageSharp && product.frontmatter.image.childImageSharp.fluid){
      return  <Img
        fluid={product.frontmatter.image.childImageSharp.fluid} />
    }
    else{
      return <div/>
    }
  }
};
const ProductListingItemLink = styled(Link)`
  border-radius: 4px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 1);
  margin-bottom: 16px;
  overflow: hidden;
  text-decoration: none;

  @media (min-width: ${breakpoints.tablet}px) {
    margin-left: auto;
    margin-right: auto;
    max-width: 500px;
  }

  @media (min-width: ${breakpoints.desktop}px) {
    flex-basis: 300px;
    justify-content: center;
    margin: 16px;
  }

  @media (hover: hover) {
    :hover {
      background: ${darkThemeColors.brandLighter};
    }
  }
`;

const Item = styled(`article`)`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 1px 10px rgba(0,0,0,1);
`;

const Preview = styled(`div`)`
  border-radius: 4px 4px 0 0;
  margin: -24px;
  margin-bottom: 24px;
  overflow: hidden;
  position: relative;

  .gatsby-image-wrapper {
    transition: all 250ms;
  }
`;

const Name = styled(`div`)`
  text-align: left;
  color: ${props => props.theme.lightest};
  font-size: 1.6rem;
  line-height: 1.2;
  font-weight: 500;
  margin: 0;
`;

const PriceRow = styled(`div`)`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;

const Price = styled(`div`)`
  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
  color: ${darkThemeColors.brandDark};
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: -0.02em;

  span {
    color: ${props => props.theme.lightest};
  }
`;

const Description = styled(`div`)`
  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
  text-align: left;
  color: ${props => props.theme.lightest};
  flex-grow: 1;
  font-size: 1rem;
  line-height: 1.5;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export default ProductListingItem;
